import React from "react";
import NotesHistoryPanel from "./NotesHistoryPanel";
import NotesHistoryPanelEdit from "./NotesHistoryPanelEdit";
import NotesHistoryPanelItem from "./NotesHistoryPanelItem";
import { WellnessCheckItem } from "../../../../../../models/notes/note";
import { Formatter } from "../../../../../../services/formatter/formatter.service";
import { WELLNESS_CHECK_OTHER_ID } from "../../../../../../models/notes/wellness-check-additional-categories.model";

export interface NotesHistoryWellnessCheckNoteProps {
	date: string;
	/** Display label for this wellness note type (e.g. "Wellness Check", "Wellness Check 2") */
	typeLabel: string;
	callerName: string;
	editing: boolean;
	pinned: boolean;
	pinLoading?: boolean;
	onTogglePin: () => void;
	wellnessCheckItems?: WellnessCheckItem[] | null;
	lastEditionDate?: string;
	lastEditedBy?: string;
	onClickEdit: () => void;
}

function NotesHistoryWellnessCheckNote(
	props: NotesHistoryWellnessCheckNoteProps
): React.ReactElement {
	const items = props.wellnessCheckItems ?? [];

	const getItemLabel = (topicId: string) => {
		if (topicId === WELLNESS_CHECK_OTHER_ID || topicId.endsWith("::" + WELLNESS_CHECK_OTHER_ID))
			return "PARTICIPANT.DASHBOARD.NOTES.WELLNESS_CHECK_OTHER";
		if (topicId.includes("::")) return topicId.split("::")[1] ?? topicId;
		return topicId;
	};

	return (
		<NotesHistoryPanel
			date={props.date}
			type={props.typeLabel}
			callerName={props.callerName}
			editing={props.editing}
			pinned={props.pinned}
			pinLoading={props.pinLoading}
			onTogglePin={props.onTogglePin}
		>
			<>
				{items.length === 0 ? (
					<NotesHistoryPanelItem
						label="PARTICIPANT.DASHBOARD.NOTES.WELLNESS_CHECK_TOPICS_LABEL"
						value={Formatter.NO_DATA}
					/>
				) : (
					items.map((item) => (
						<NotesHistoryPanelItem
							key={item.topicId}
							label={getItemLabel(item.topicId)}
							value={item.notes ?? undefined}
						/>
					))
				)}

				<NotesHistoryPanelEdit
					lastEditionDate={props.lastEditionDate}
					lastEditedBy={props.lastEditedBy}
					onClickEdit={props.onClickEdit}
				/>
			</>
		</NotesHistoryPanel>
	);
}

export default NotesHistoryWellnessCheckNote;
